export default function scrollToTop(event: any, top = 0): void {
  event.preventDefault();

  window.scrollTo({
    behavior: 'smooth',
    top: top,
  });
  // Remove the focus of the icon once you've clicked on it, preventing a state where the
  // icon would stay in a transformed state once you scroll up again
  event.currentTarget.blur();
}
